<template>
  <form>
    <div class="layout">
      <div class="layout__header">
        <div class="layout__title">
          <h3>Parametros del sistema</h3>
        </div>
        <div class="layout__controls">
          <div class="form-inline">
            <button
              type="button"
              class="btn-secondary"
              @click="abrirComisiones"
            >
              <i class="fa fa-list-alt"></i><span>Comisiones</span>
            </button>
            <button
              type="button"
              class="btn-primary"
              @click="abrirPreferencias"
            >
              <i class="fa fa-cog"></i><span>Preferencias</span>
            </button>
            <button
              v-if="superadmin === 'S'"
              type="button"
              class="btn-bus200 btn--bigger"
              @click="abrirBillRobot"
            >
              <span>My BillBot</span>
            </button>
          </div>
        </div>
      </div>
      <div class="layout__main">
        <div class="layout__main-form">
          <div class="row mb-0">
            <div class="col-xs-12">
              <div class="card">
                <div class="card__title">
                  <h5>Información de la empresa</h5>
                </div>
                <div class="card__content">
                  <div class="row">
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <input-field
                          placeholder="Nombre comercial o abreviado"
                          type="text"
                          v-model="form.nombre_comercial"
                          id="nombre_abreviado"
                        >
                          <span>Nombre comercial *</span>
                          <span
                            v-if="errores.nombre_comercial"
                            class="helper-text text-danger"
                            slot="helper"
                          >
                            <strong>{{ errores.nombre_comercial[0] }}</strong>
                          </span>
                        </input-field>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <input-field
                          placeholder="Razón social de la empresa o persona"
                          type="text"
                          v-model="form.razon_social"
                          id="razon_social"
                        >
                          <span>Razón social *</span>
                          <span
                            v-if="errores.razon_social"
                            class="helper-text text-danger"
                            slot="helper"
                          >
                            <strong>{{ errores.razon_social[0] }}</strong>
                          </span>
                        </input-field>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <input-field
                          placeholder="Número de RUC"
                          type="text"
                          v-model="form.ruc_contribuyente"
                          id="ruc_empresa"
                        >
                          <span>RUC *</span>
                          <span
                            v-if="errores.ruc_contribuyente"
                            class="helper-text text-danger"
                            slot="helper"
                          >
                            <strong>{{ errores.ruc_contribuyente[0] }}</strong>
                          </span>
                        </input-field>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <input-field
                          placeholder="Página web"
                          type="text"
                          v-model="form.sitio_web"
                          id="paginaWeb"
                        >
                          <span>Página web</span>
                          <span
                            v-if="errores.pagina_web"
                            class="helper-text text-danger"
                            slot="helper"
                          >
                            <strong>{{ errores.pagina_web[0] }}</strong>
                          </span>
                        </input-field>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <input-field
                          vMoney
                          :format="porcentaje"
                          placeholder="% ##.##"
                          type="text"
                          v-model="form.retencion_productos"
                          id="retencionProductos"
                        >
                          <span>% Retención de productos</span>
                          <span
                            v-if="errores.retencion_productos"
                            class="helper-text text-danger"
                            slot="helper"
                          >
                            <strong>{{
                              errores.retencion_productos[0]
                            }}</strong>
                          </span>
                        </input-field>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <input-field
                          vMoney
                          :format="porcentaje"
                          placeholder="% ##.##"
                          type="text"
                          v-model="form.retencion_servicios"
                          id="retencionServicios"
                        >
                          <span>% Retención de servicios</span>
                          <span
                            v-if="errores.retencion_servicios"
                            class="helper-text text-danger"
                            slot="helper"
                          >
                            <strong>{{
                              errores.retencion_servicios[0]
                            }}</strong>
                          </span>
                        </input-field>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <input-field
                          vMoney
                          :format="money"
                          placeholder="$ ##.##"
                          type="text"
                          v-model="form.comision_base"
                          id="comision_base"
                        >
                          <span>Monto base de comisiones</span>
                          <span
                            v-if="errores.comision_base"
                            class="helper-text text-danger"
                            slot="helper"
                          >
                            <strong>{{ errores.comision_base[0] }}</strong>
                          </span>
                        </input-field>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <input-field
                          vMoney
                          :format="porcentaje"
                          placeholder="% ##.##"
                          type="text"
                          v-model="form.porcentaje_comision"
                          id="porcentaje_comision"
                        >
                          <span>% Porcentaje de comisión</span>
                          <span
                            v-if="errores.porcentaje_comision"
                            class="helper-text text-danger"
                            slot="helper"
                          >
                            <strong>{{
                              errores.porcentaje_comision[0]
                            }}</strong>
                          </span>
                        </input-field>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <input-field
                          placeholder="Correo electrónico"
                          type="text"
                          v-model="form.email_empresa"
                          id="email"
                        >
                          <span>E-mail *</span>
                          <span
                            v-if="errores.email_empresa"
                            class="helper-text text-danger"
                            slot="helper"
                          >
                            <strong>{{ errores.email_empresa[0] }}</strong>
                          </span>
                        </input-field>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <input-field
                          placeholder="Dirección de la empresa o persona"
                          type="text"
                          v-model="form.direccion_empresa"
                          id="direccion"
                        >
                          <span>Dirección *</span>
                          <span
                            v-if="errores.direccion_empresa"
                            class="helper-text text-danger"
                            slot="helper"
                          >
                            <strong>{{ errores.direccion_empresa[0] }}</strong>
                          </span>
                        </input-field>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <input-field
                          vMoney
                          :format="int"
                          type="text"
                          v-model="form.telefono"
                          id="telefono_1"
                          placeholder="Teléfono principal"
                        >
                          <span>Teléfono 1</span>
                          <span
                            v-if="errores.telefono"
                            class="helper-text text-danger"
                            slot="helper"
                          >
                            <strong>{{ errores.telefono[0] }}</strong>
                          </span>
                        </input-field>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <input-field
                          vMoney
                          :format="int"
                          type="text"
                          v-model="form.telefono2"
                          id="telefono_2"
                          placeholder="Teléfono secundario"
                        >
                          <span>Teléfono 2</span>
                          <span
                            v-if="errores.telefono2"
                            class="helper-text text-danger"
                            slot="helper"
                          >
                            <strong>{{ errores.telefono2[0] }}</strong>
                          </span>
                        </input-field>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <input-field
                          type="text"
                          v-model="form.fax"
                          id="fax"
                          placeholder="Fax de la empresa o persona"
                        >
                          <span>FAX</span>
                          <span
                            v-if="errores.fax"
                            class="helper-text text-danger"
                            slot="helper"
                          >
                            <strong>{{ errores.fax[0] }}</strong>
                          </span>
                        </input-field>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field select2">
                        <div class="select2-field">
                          <v-select
                            :options="paises"
                            label="nombre"
                            id="pais"
                            placeholder="Seleccione..."
                            v-model="selectedPais"
                          ></v-select>
                          <label for="pais">País</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field select2">
                        <div class="select2-field">
                          <v-select
                            :options="provincias"
                            label="nombre"
                            id="pais"
                            placeholder="Seleccione..."
                            v-model="selectedProvincia"
                          ></v-select>
                          <label for="pais">Provincia</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field select2">
                        <div class="select2-field">
                          <v-select
                            :options="ciudades"
                            label="nombre"
                            id="ciudad"
                            placeholder="Seleccione..."
                            v-model="selectedCiudad"
                          ></v-select>
                          <label for="ciudad">Ciudad</label>
                          <span
                            v-if="errores.ciudad"
                            class="helper-text text-danger"
                            slot="helper"
                          >
                            <strong>{{ errores.ciudad[0] }}</strong>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <label for="contribuyente_especial">
                          <input
                            type="checkbox"
                            class="is-filled"
                            v-model="form.contribuyente_especial"
                            id="contribuyente_especial"
                          />
                          <span>Contribuyente especial</span>
                        </label>
                        <span
                          v-if="errores.contribuyente_especial"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{
                            errores.contribuyente_especial[0]
                          }}</strong>
                        </span>
                      </div>
                    </div>
                    <div
                      class="col-xs-12 col-md-6 col-lg-4"
                      v-show="form.contribuyente_especial"
                    >
                      <div class="form-field">
                        <input-field
                          v-model="form.numero_cont_espec"
                          id="resContribuyenteEspecial"
                          placeholder="N° de contribuyente"
                        >
                          <span>Res. Contribuyente Especial</span>
                          <span
                            v-if="errores.numero_cont_espec"
                            class="helper-text text-danger"
                            slot="helper"
                          >
                            <strong>{{ errores.numero_cont_espec[0] }}</strong>
                          </span>
                        </input-field>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <input-field
                          v-model="form.detalle_adicional_venta"
                          id="detalle_adicional_venta"
                          placeholder="Escriba un detalle..."
                        >
                          <span>Detalle adicional de venta</span>
                          <span
                            v-if="errores.detalle_adicional_venta"
                            class="helper-text text-danger"
                            slot="helper"
                          >
                            <strong>{{
                              errores.detalle_adicional_venta[0]
                            }}</strong>
                          </span>
                        </input-field>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <input-field
                          v-model="form.monto_maximo_cf"
                          id="monto_maximo_cf"
                          placeholder="Escriba un monto..."
                        >
                          <span>Monto máximo de consumidor final</span>
                          <span
                            v-if="errores.monto_maximo_cf"
                            class="helper-text text-danger"
                            slot="helper"
                          >
                            <strong>{{ errores.monto_maximo_cf[0] }}</strong>
                          </span>
                        </input-field>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <label for="exportador">
                          <input
                            type="checkbox"
                            class="is-filled"
                            v-model="form.exportador"
                            id="exportador"
                          />
                          <span>Exportador</span>
                        </label>
                        <span
                          v-if="errores.exportador"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{ errores.exportador[0] }}</strong>
                        </span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <label for="obligadoContabilidad">
                          <input
                            type="checkbox"
                            v-model="form.obligado_contabilidad"
                            id="obligadoContabilidad"
                          />
                          <span>Obligado a llevar contabilidad</span>
                        </label>
                        <span
                          v-if="errores.obligado_contabilidad"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{
                            errores.obligado_contabilidad[0]
                          }}</strong>
                        </span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4 d-flex ai-center">
                      <div class="form-inline">
                        <div class="form-field">
                          <label for="esMicroempresa">
                            <input
                              type="checkbox"
                              v-model="form.es_microempresa"
                              id="esMicroempresa"
                            />
                            <span>Es RIMPE</span>
                          </label>
                        </div>
                        <div v-show="form.es_microempresa" class="form-field">
                          <label for="es_negocio_popular">
                            <input
                              type="checkbox"
                              v-model="form.es_negocio_popular"
                              id="es_negocio_popular"
                            />
                            <span>Es negocio popular</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <input-field
                          v-model="form.resolucion_agente_retencion"
                          id="resolucion_agente_retencion"
                          placeholder="###"
                        >
                          <span>Resolución de agente de retención</span>
                        </input-field>
                        <span
                          v-if="errores.resolucion_agente_retencion"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{
                            errores.resolucion_agente_retencion[0]
                          }}</strong>
                        </span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <input-field
                          v-model="form.calificacion_artesanal"
                          id="calificacion_artesanal"
                          placeholder="###"
                        >
                          <span>Calificación artesanal</span>
                        </input-field>
                        <span
                          v-if="errores.calificacion_artesanal"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{
                            errores.calificacion_artesanal[0]
                          }}</strong>
                        </span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <input-field
                          v-model="form.url_facebook"
                          id="url_facebook"
                          placeholder="@"
                        >
                          <span>Facebook</span>
                        </input-field>
                        <span
                          v-if="errores.url_facebook"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{
                            errores.url_facebook[0]
                          }}</strong>
                        </span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <input-field
                          v-model="form.url_instagram"
                          id="url_instagram"
                          placeholder="@"
                        >
                          <span>Instagram</span>
                        </input-field>
                        <span
                          v-if="errores.url_instagram"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{
                            errores.url_instagram[0]
                          }}</strong>
                        </span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <input-field
                          v-model="form.url_twitter"
                          id="url_twitter"
                          placeholder="@"
                        >
                          <span>Twitter</span>
                        </input-field>
                        <span
                          v-if="errores.url_twitter"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{
                            errores.url_twitter[0]
                          }}</strong>
                        </span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field">
                        <label for="calcular_totales_final">
                          <input
                            type="checkbox"
                            class="is-filled"
                            v-model="form.calcular_totales_final"
                            id="calcular_totales_final"
                          />
                          <span
                            >Calcular impuestos respecto a los totales
                            finales</span
                          >
                        </label>
                        <span
                          v-if="errores.calcular_totales_final"
                          class="helper-text text-danger"
                          slot="helper"
                        >
                          <strong>{{
                            errores.calcular_totales_final[0]
                          }}</strong>
                        </span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-8">
                      <div class="form-field">
                        <textarea-field
                          v-model="form.footer_ride"
                          id="footer_ride"
                          placeholder="Escriba el pie de página del ride..."
                        >
                        <span>Pie de Página de RIDE</span>
                        <span v-if="errores.footer_ride" class="helper-text text-danger" slot="helper">
                          {{ errores.footer_ride[0] }}
                        </span>
                        </textarea-field>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field select2">
                        <div class="select2-field">
                          <v-select
                            :options="paises"
                            label="nombre"
                            id="pais_defecto"
                            placeholder="Seleccione..."
                            @input="inputPaisDefecto"
                            v-model="selectedPaisDefecto"
                          ></v-select>
                          <label for="pais_defecto">País de persona por defecto</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field select2">
                        <div class="select2-field">
                          <v-select
                            :options="provinciasDefecto"
                            label="nombre"
                            id="provincia_defecto"
                            placeholder="Seleccione..."
                            @input="inputProvinciaDefecto"
                            v-model="selectedProvinciaDefecto"
                          ></v-select>
                          <label for="provincia_defecto">Provincia de persona por defecto</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-4">
                      <div class="form-field select2">
                        <div class="select2-field">
                          <v-select
                            :options="ciudadesDefecto"
                            label="nombre"
                            id="ciudad_defecto"
                            placeholder="Seleccione..."
                            @input="inputCiudadDefecto"
                            v-model="selectedCiudadDefecto"
                          ></v-select>
                          <label for="ciudad_defecto">Ciudad de persona por defecto</label>
                          <span
                            v-if="errores.ciudad_defecto_id"
                            class="helper-text text-danger"
                            slot="helper"
                          >
                            <strong>{{ errores.ciudad_defecto_id[0] }}</strong>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 col-lg-8">
                      <div class="form-field select2">
                        <div class="select2-field">
                          <v-select
                            :options="personasDefecto"
                            label="descripcion"
                            id="persona_defecto_id"
                            placeholder="Seleccione..."
                            @input="inputPersonaDefecto"
                            v-model="selectedPersona"
                            @search="searchPersonas"
                          ></v-select>
                          <label for="persona_defecto_id">Persona por defecto</label>
                          <span
                            v-if="errores.persona_defecto_id"
                            class="helper-text text-danger"
                            slot="helper"
                          >
                            <strong>{{ errores.persona_defecto_id[0] }}</strong>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                      <div class="form-field">
                        <div class="multiselect-field">
                          <multiselect
                            v-model="selectedCorreosCopiaOcultaAutorizacion"
                            tag-placeholder="Agrega uno o más correos..."
                            placeholder="Agrega uno o más correos..."
                            selectedLabel="Seleccionado"
                            deselectLabel="Presiona enter para eliminar"
                            id="correos_copia_oculta_autorizacion"
                            ref="multi_cco_auth"
                            label="descripcion"
                            track-by="descripcion"
                            :options="selectedCorreosCopiaOcultaAutorizacion"
                            :multiple="true"
                            :taggable="true"
                            :showNoResults="false"
                            :showNoOptions="false"
                            hideSelected
                            @input="inputCorreosCopiaOcultaAutorizacion()"
                            @tag="addTagCorreosCopiaOcultaAutorizacion"
                          >
                          </multiselect>
                          <label for="correos_copia_oculta_autorizacion">Correos para autorización (con copia oculta)</label>
                          <span
                            v-if="errores.correos_copia_oculta_autorizacion"
                            class="helper-text text-danger"
                            slot="helper"
                          >
                            <strong>{{ errores.correos_copia_oculta_autorizacion[0] }}</strong>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-4">
                      <div class="form-field select2">
                        <div class="select2-field">
                          <v-select
                            :options="formasPago"
                            :tooltip="selectedFormaPagoDefault ? selectedFormaPagoDefault.nombre : null"
                            label="nombre"
                            id="forma_pago_id_default"
                            placeholder="Seleccione..."
                            @input="inputFormaPagoDefault"
                            v-model="selectedFormaPagoDefault"
                          ></v-select>
                          <label for="forma_pago_id_default">Forma de pago por defecto</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-4">
              <div class="card mt-3 max-content">
                <div class="card__title">
                  <h5>Logo de la empresa</h5>
                </div>
                <div class="card__content">
                  <div class="file-logo-upload">
                    <img
                      id="logoImg"
                      class="file-logo-upload__img"
                      :src="urlLogo"
                      alt="Logo"
                    />
                    <form
                      :action="url + '/parametros/imagen'"
                      id="form_imagen"
                      enctype="multipart/form-data"
                      method="post"
                    >
                      <input type="hidden" name="_token" :value="token" />
                      <input
                        @change="readUrl"
                        type="file"
                        class="file-logo-upload__input"
                        name="logo"
                        id="logo"
                      />
                      <label for="logo" class="file-logo-upload__label"
                        ><i class="fa fa-upload"></i
                      ></label>
                      <button
                        type="button"
                        class="file-logo-upload__button btn-secondary"
                        onclick="document.getElementById('form_imagen').submit()"
                      >
                        <i class="fa fa-refresh"></i><span>Cambiar logo</span>
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 col-md-4">
              <div class="card mt-3 max-content">
                <div class="card__title">
                  <h5>QR en RIDE</h5>
                </div>
                <div class="card__content">
                  <div class="file-logo-upload">
                    <img
                      id="logoImgQr"
                      class="file-logo-upload__img"
                      :src="urlQr"
                      alt="QR"
                    />
                    <form
                      :action="url + '/parametros/qr'"
                      id="form_qr"
                      enctype="multipart/form-data"
                      method="post"
                    >
                      <input type="hidden" name="_token" :value="token" />
                      <input
                        @change="readUrlQR"
                        type="file"
                        class="file-logo-upload__input"
                        name="qr"
                        id="qr"
                      />
                      <label for="qr" class="file-logo-upload__label"
                        ><i class="fa fa-upload"></i
                      ></label>
                      <button
                        type="button"
                        class="file-logo-upload__button btn-secondary"
                        onclick="document.getElementById('form_qr').submit()"
                      >
                        <i class="fa fa-refresh"></i><span>Cambiar QR</span>
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="layout__main-buttons">
          <div class="card">
            <div class="card__content">
              <button @click="guardarCambios" class="btn-success" type="button">
                <i class="fa fa-save"></i> <span>Guardar</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <modal
        :width="'60%'"
        :clickToClose="false"
        height="auto"
        :scrollable="true"
        name="robot"
        ref="robot"
      >
        <parametros-bill-bot
          @cerrarModalBot="cerrarBillRobot"
        ></parametros-bill-bot>
      </modal>
      <modal
        :width="'85%'"
        :clickToClose="false"
        height="auto"
        :scrollable="true"
        name="preferencias"
        ref="preferencias"
      >
        <parametros-preferencias
          :superadmin="superadmin"
          @cerrar="cerrarPreferencias"
        ></parametros-preferencias>
      </modal>
      <modal
        :width="'70%'"
        :clickToClose="false"
        height="auto"
        :scrollable="true"
        name="comisiones"
        ref="comisiones"
      >
        <comisiones/>
      </modal>
    </div>
  </form>
</template>
<script>
export default {
  props: {
    token: {
      type: String,
      required: true,
    },
    superadmin: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      personasDefecto: [],
      selectedPersona: null,
      selectedCiudadDefecto: null,
      selectedPaisDefecto: null,
      selectedProvinciaDefecto: null,
      money: money,
      porcentaje: porcentaje,
      selectedCorreosCopiaOcultaAutorizacion: [],
      formasPago: [],
      selectedFormaPagoDefault: null,
      form: {
        persona_defecto_id: '',
        ciudad_defecto_id: '',
        url_facebook: '',
        url_instagram: '',
        url_twitter: '',
        path_qr: '',
        footer_ride: '',
        calcular_totales_final: false,
        calificacion_artesanal: "",
        resolucion_agente_retencion: "",
        es_microempresa: false,
        es_negocio_popular: false,
        monto_maximo_cf: 0,
        detalle_adicional_venta: "",
        porcentaje_comision: 0,
        comision_base: 0,
        nombre_comercial: "",
        razon_social: "",
        ruc_contribuyente: "",
        telefono: "",
        telefono2: "",
        fax: "",
        email_empresa: "",
        id_ciudad: "",
        direccion_empresa: "",
        contribuyente_especial: false,
        exportador: false,
        numero_cont_espec: "",
        obligado_contabilidad: true,
        retencion_productos: 0,
        retencion_servicios: 0,
        sitio_web: "",
        correos_copia_oculta_autorizacion: '',
        forma_pago_id_default: '',
      },
      errores: {
        nombre_comercial: undefined,
        razon_social: undefined,
        ruc_contribuyente: undefined,
        telefono: undefined,
        telefono2: undefined,
        fax: undefined,
        email_empresa: undefined,
        id_ciudad: undefined,
        direccion_empresa: undefined,
        numero_cont_espec: undefined,
        obligado_contabilidad: undefined,
        correos_copia_oculta_autorizacion: undefined,
      },
      selectedCiudad: null,
      selectedPais: null,
      selectedProvincia: null,
      paises: [],
      ciudades: [],
      provincias: [],
      provinciasDefecto: [],
      ciudadesDefecto: [],
      url: url,
      empresa: null,
      urlLogo: null,
      int: numero,
      provinciaActual: "",
      ciudadActual: "",
      urlQr: null
    };
  },
  watch: {
    selectedCiudad: function (value) {
      if (value !== undefined && value !== null)
        this.form.id_ciudad = value.id_ciudad;
      else this.form.id_ciudad = "";
    },
    selectedPais: function (value) {
      if (value !== undefined && value !== null) this.cargarProvincias();
      else this.selectedProvincia = null;
    },
    selectedProvincia: function (value) {
      if (value !== undefined && value !== null) this.cargarCiudades();
      else this.selectedCiudad = null;
    },
  },
  methods: {
    inputFormaPagoDefault: function(){
      if(this.selectedFormaPagoDefault)
        this.form.forma_pago_id_default = this.selectedFormaPagoDefault.id_forma_pago;
      else
        this.form.forma_pago_id_default = '';
    },
    cargarTagCorreosCopiaOcultaAutorizacion: function(){
      if(this.form.correos_copia_oculta_autorizacion != null && this.form.correos_copia_oculta_autorizacion !=  ''){
        let emails = this.form.correos_copia_oculta_autorizacion.split(',');
        this.selectedCorreosCopiaOcultaAutorizacion.splice(0, this.selectedCorreosCopiaOcultaAutorizacion, ...emails.map((email) => {
          return {
            descripcion: email,
          }
        }));
      }
    },
    inputCorreosCopiaOcultaAutorizacion: function(){
      let strTag = this.selectedCorreosCopiaOcultaAutorizacion.map((tag) => tag.descripcion).join(',');
      this.form.correos_copia_oculta_autorizacion = strTag;
    },
    addTagCorreosCopiaOcultaAutorizacion: function(newTag){
      const tag = {
        descripcion: newTag,
      }
      this.selectedCorreosCopiaOcultaAutorizacion.push(tag);
      let strTag = this.selectedCorreosCopiaOcultaAutorizacion.map((tag) => tag.descripcion).join(',');
      this.form.correos_copia_oculta_autorizacion = strTag;
      this.$refs.multi_cco_auth.$el.focus();
    },
    abrirComisiones: function () {
      this.$modal.show("comisiones");
    },
    inputPersonaDefecto: function () {
      if (this.selectedPersona != null) 
        this.form.persona_defecto_id = this.selectedPersona.id;
      else 
        this.form.persona_defecto_id = '';
    },
    inputPaisDefecto: function () {
      this.cargarProvinciasDefecto();
    },
    inputProvinciaDefecto: function () {
      this.cargarCiudadesDefecto();
    },
    inputCiudadDefecto: function () {
      if (this.selectedCiudadDefecto != null)
        this.form.ciudad_defecto_id = this.selectedCiudadDefecto.id_ciudad;
      else 
        this.form.ciudad_defecto_id = '';
    },
    readUrlQR: function () {
      let input = document.getElementById("qr");
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        reader.onload = function (e) {
          document.getElementById("logoImgQr").src = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    cargarProvinciasDefecto: function () {
      let that = this;
      axios
        .get(this.url + "/provincias/" + that.selectedPaisDefecto.id_pais)
        .then(function (response) {
          that.provinciasDefecto = response.data;
        });
    },
    cargarCiudadesDefecto: function () {
      let that = this;
      axios
        .get(this.url + "/ciudades/" + that.selectedProvinciaDefecto.id_provincia)
        .then(function (response) {
          that.ciudadesDefecto = response.data;
        });
    },
    cargarProvincias: function () {
      let that = this;
      axios
        .get(this.url + "/provincias/" + that.selectedPais.id_pais)
        .then(function (response) {
          that.provincias = response.data;
          for (let i = 0; i < that.provincias.length; i++)
            if (that.provincias[i].id_provincia === that.provinciaActual) {
              that.selectedProvincia = that.provincias[i];
              break;
            }
        });
    },
    limpiarErrores: function () {
      this.errores = {
        nombre_comercial: undefined,
        razon_social: undefined,
        ruc_contribuyente: undefined,
        telefono: undefined,
        telefono_2: undefined,
        fax: undefined,
        email_empresa: undefined,
        id_ciudad: undefined,
        direccion_empresa: undefined,
        numero_cont_espec: undefined,
        obligado_contabilidad: undefined,
      };
    },
    guardarCambios: function () {
      let that = this;
      this.limpiarErrores();
      axios
        .post(that.url + "/parametros", that.form)
        .then(function (response) {
          swal("Los datos han sido almacenados.", "Mensaje", "success");
        })
        .catch(function (error) {
          if (error !== undefined && error !== null) {
            let response = error.response;
            if (response !== undefined && response !== null) {
              if (response.status === 422) {
                that.errores = response.data.errors;
                swal(
                  "Verifique los datos ingresados, ya que tienen errores.",
                  "Error",
                  "warning"
                );
              } else
                swal(
                  "Hubo un error al momento de almacenar los datos.",
                  "Intente nuevamente.",
                  "error"
                );
            }
          }
        });
    },
    readUrl: function (e) {
      console.log(e)
      let input = document.getElementById("logo");
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        reader.onload = function (e) {
          document.getElementById("logoImg").src = e.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    abrirBillRobot: function () {
      this.$modal.show("robot");
    },
    abrirPreferencias: function () {
      this.$modal.show("preferencias");
    },
    cerrarBillRobot: function () {
      this.$modal.hide("robot");
    },
    cerrarPreferencias: function () {
      this.$modal.hide("preferencias");
    },
    cargarDatosFormulario: function () {
      let that = this;
      axios.get(this.url + "/parametros/datos").then(function (response) {
        let data = response.data;
        that.paises = data.paises;
        that.empresa = data.empresa;
        if (data.configuracionEmpresa !== null) {
          let configuracionEmpresa = data.configuracionEmpresa;
          that.form.url_facebook = configuracionEmpresa.url_facebook;
          that.form.url_instagram = configuracionEmpresa.url_instagram;
          that.form.url_twitter = configuracionEmpresa.url_twitter;
          that.form.footer_ride = configuracionEmpresa.footer_ride;
          that.formasPago = data.formasPago;
          that.form.calcular_totales_final =
            configuracionEmpresa.calcular_totales_final === "S";
          that.form.calificacion_artesanal =
            configuracionEmpresa.calificacion_artesanal;
          that.form.es_microempresa =
            configuracionEmpresa.es_microempresa === "S";
          that.form.es_negocio_popular =
            configuracionEmpresa.es_negocio_popular === "S";
          that.form.resolucion_agente_retencion =
            configuracionEmpresa.resolucion_agente_retencion;
          that.form.detalle_adicional_venta =
            configuracionEmpresa.detalle_adicional_venta;
          that.form.monto_maximo_cf = configuracionEmpresa.monto_maximo_cf;
          that.form.porcentaje_comision =
            configuracionEmpresa.porcentaje_comision;
          that.form.comision_base = configuracionEmpresa.comision_base;
          that.form.nombre_comercial = configuracionEmpresa.nombre_comercial;
          that.form.razon_social = configuracionEmpresa.razon_social;
          that.form.exportador = configuracionEmpresa.exportador === "S";
          that.form.numero_cont_espec = configuracionEmpresa.numero_cont_espec;
          that.form.ruc_contribuyente = configuracionEmpresa.ruc_contribuyente;
          that.form.telefono = configuracionEmpresa.telefono;
          that.form.telefono2 = configuracionEmpresa.telefono2;
          that.form.fax = configuracionEmpresa.fax;
          that.form.obligado_contabilidad =
            configuracionEmpresa.obligado_contabilidad === "S";
          that.form.email_empresa = configuracionEmpresa.email_empresa;
          that.form.direccion_empresa = configuracionEmpresa.direccion_empresa;
          that.form.contribuyente_especial =
            configuracionEmpresa.contribuyente_especial === "S";
          that.form.sitio_web = configuracionEmpresa.sitio_web;
          that.form.retencion_productos =
            configuracionEmpresa.retencion_productos;
          that.form.retencion_servicios =
            configuracionEmpresa.retencion_servicios;
          if (configuracionEmpresa.logo_empresa !== null)
            that.urlLogo =
              that.url + "/storage/" + configuracionEmpresa.logo_empresa;
          if (configuracionEmpresa.path_qr !== null)
          that.urlQr =
            that.url + "/storage/" + configuracionEmpresa.path_qr;
          if (configuracionEmpresa.ciudad !== null)
            for (let i = 0; i < that.paises.length; i++)
              if (
                that.paises[i].id_pais ===
                configuracionEmpresa.ciudad.provincia.id_pais
              ) {
                that.selectedPais = that.paises[i];
                that.provinciaActual = configuracionEmpresa.ciudad.id_provincia;
                that.ciudadActual = configuracionEmpresa.id_ciudad;
                break;
              }
          that.form.numero_cont_espec = configuracionEmpresa.numero_cont_espec;
          if (configuracionEmpresa.ciudad_defecto != null) {
            that.selectedPaisDefecto = configuracionEmpresa.ciudad_defecto.provincia.pais;
            that.cargarProvinciasDefecto();
            that.selectedProvinciaDefecto = configuracionEmpresa.ciudad_defecto.provincia;
            that.cargarCiudadesDefecto();
            that.selectedCiudadDefecto = configuracionEmpresa.ciudad_defecto;
            that.form.ciudad_defecto_id = configuracionEmpresa.ciudad_defecto_id;
          }
          if (configuracionEmpresa.persona_defecto != null) {
            that.selectedPersona = configuracionEmpresa.persona_defecto;
            that.form.persona_defecto_id = configuracionEmpresa.persona_defecto.id;
          }
          that.form.correos_copia_oculta_autorizacion = configuracionEmpresa.correos_copia_oculta_autorizacion;
          that.cargarTagCorreosCopiaOcultaAutorizacion();
          that.form.forma_pago_id_default = configuracionEmpresa.forma_pago_id_default;
          that.selectedFormaPagoDefault = data.formasPago.find(fp => fp.id_forma_pago === configuracionEmpresa.forma_pago_id_default);
        } else {
          that.form.nombre_comercial = data.empresa.nombre_comercial;
          that.form.ruc_contribuyente = data.empresa.ruc;
          that.form.razon_social = data.empresa.razon_social;
        }
      });
    },
    searchPersonas: function(search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function() {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.personasDefecto = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/consultar-personas?search=" + search, true);
      xmlhttp.send();
    },
    cargarCiudades: function () {
      let that = this;
      axios
        .get(this.url + "/ciudades/" + that.selectedProvincia.id_provincia)
        .then(function (response) {
          that.ciudades = response.data;
          for (let i = 0; i < that.ciudades.length; i++)
            if (that.ciudades[i].id_ciudad == that.ciudadActual) {
              that.selectedCiudad = that.ciudades[i];
              break;
            }
        });
    },
  },
  mounted: function () {
    this.urlLogo = this.url + "/images/no-logo.png";
    this.urlQr = this.url + "/images/no-logo.png";
    this.cargarDatosFormulario();
  },
};
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/parametrizacion/ParametrosGeneral.vue